<script lang="ts">
  import { tStore } from '../i18n'

  interface Props {
    message: string
    // Raw exception text from the ingestion pipeline. Shown collapsed behind
    // "Technical details" for support/debugging; omitted when it wouldn't add
    // anything beyond `message`.
    detail?: string | null
  }

  let { message, detail = null }: Props = $props()
</script>

<div class="unavailable-notice warning">
  <p class="unavailable-notice__message">{message}</p>
  {#if detail && detail !== message}
    <details class="unavailable-notice__details">
      <summary>{$tStore('views.procurementDetail.sourceStatus.technicalDetails')}</summary>
      <p class="mono">{detail}</p>
    </details>
  {/if}
</div>

<style lang="scss">
  @use '../assets/styles/variables' as v;

  .unavailable-notice {
    display: flex;
    flex-direction: column;
    gap: v.$space-xs;
  }

  .unavailable-notice__message {
    margin: 0;
  }

  .unavailable-notice__details {
    font-size: 0.85em;

    summary {
      cursor: pointer;
    }

    p {
      margin: v.$space-xs 0 0;
      white-space: pre-wrap;
    }
  }
</style>
